import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i3 from 'base-review-petition-library';
import { BaseReviewPetitionLibraryService } from 'base-review-petition-library';
import { first } from 'rxjs/internal/operators/first';
import * as i1 from 'authentication';
import * as i2 from '@ngrx/store';
import * as i4 from 'ngx-toastr';
import * as i5 from 'step-status-update-payload-service';
import * as i6 from 'dirty-check-store';
import * as i7 from 'primeng/dynamicdialog';
import * as i8 from 'app-services-library';
import * as i9 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i10 from '@angular/forms';
import * as i11 from 'primeng/tabview';
import * as i12 from 'review-petiton-new';
import { ReviewPetitonNewModule } from 'review-petiton-new';
import * as i13 from 'step-status-update-component-library';
import { StepStatusUpdateComponentLibraryModule } from 'step-status-update-component-library';
import * as i14 from 'maximize-dialog-library';
import { MaximizeDialogLibraryModule } from 'maximize-dialog-library';
import * as i15 from 'assigning-task-library';
import { AssigningTaskLibraryModule } from 'assigning-task-library';
import * as i16 from 'primeng/divider';
import * as i17 from 'last-update-library';
import { LastUpdateLibraryModule } from 'last-update-library';
import * as i18 from 'primeng/button';
import * as i19 from 'primeng/dropdown';
import * as i20 from 'primeng/api';
import * as i21 from 'primeng/inputtext';
import { PrimengLibraryModule } from 'primeng-library';
import { ReviewCommentsLibraryModule } from 'review-comments-library';
import * as i1$1 from 'ngx-permissions';
import { NgxPermissionsModule } from 'ngx-permissions';
import { DateFormatModule } from 'date-format';

class ReviewPetitionLibraryService {
    constructor() { }
}
ReviewPetitionLibraryService.ɵfac = function ReviewPetitionLibraryService_Factory(t) { return new (t || ReviewPetitionLibraryService)(); };
ReviewPetitionLibraryService.ɵprov = i0.ɵɵdefineInjectable({ token: ReviewPetitionLibraryService, factory: ReviewPetitionLibraryService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitionLibraryService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = ["printReviewForm"];
const _c1 = function (a0) { return { "layoutCode": a0 }; };
function ReviewPetitionLibraryComponent_ng_container_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "div", 16);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4, "Review Petition ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p");
    i0.ɵɵtext(6, "Generate Draft Petition & Notify the reviewer ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 17);
    i0.ɵɵelement(8, "lib-step-status-update-component-library", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 19);
    i0.ɵɵelement(10, "lib-maximize-dialog-library", 20);
    i0.ɵɵelementStart(11, "i", 21);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_ng_container_1_div_1_Template_i_click_11_listener() { i0.ɵɵrestoreView(_r13); const ctx_r12 = i0.ɵɵnextContext(2); return ctx_r12.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("visaType", ctx_r11.inputData.caseType != "I130" ? ctx_r11.inputData.visatype : ctx_r11.inputData.caseType)("stepDetails", ctx_r11.stepDetails)("isViewMode", ctx_r11.inputData["isViewMode"])("isCaseRequest", ctx_r11.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c1, ctx_r11.inputData == null ? null : ctx_r11.inputData.layoutCode));
} }
function ReviewPetitionLibraryComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReviewPetitionLibraryComponent_ng_container_1_div_1_Template, 12, 7, "div", 13);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.isSimplifyH1b ? false : true);
} }
function ReviewPetitionLibraryComponent_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵelementStart(1, "div", 15);
    i0.ɵɵelementStart(2, "div", 24);
    i0.ɵɵelementStart(3, "h2");
    i0.ɵɵtext(4, "Review Petition ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "p", 25);
    i0.ɵɵtext(6, "Generate Draft Petition & Notify the reviewer ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(7, "div", 26);
    i0.ɵɵelementStart(8, "ul");
    i0.ɵɵelementStart(9, "li", 27);
    i0.ɵɵelement(10, "lib-step-status-update-component-library", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "li", 28);
    i0.ɵɵelement(12, "lib-maximize-dialog-library", 20);
    i0.ɵɵelementStart(13, "i", 21);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_ng_container_2_div_1_Template_i_click_13_listener() { i0.ɵɵrestoreView(_r16); const ctx_r15 = i0.ɵɵnextContext(2); return ctx_r15.handleClose(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(10);
    i0.ɵɵproperty("visaType", ctx_r14.inputData.caseType != "I130" ? ctx_r14.inputData.visatype : ctx_r14.inputData.caseType)("stepDetails", ctx_r14.stepDetails)("isViewMode", ctx_r14.inputData["isViewMode"])("isCaseRequest", ctx_r14.inputData["isCaseRequest"]);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("configData", i0.ɵɵpureFunction1(5, _c1, ctx_r14.inputData == null ? null : ctx_r14.inputData.layoutCode));
} }
function ReviewPetitionLibraryComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReviewPetitionLibraryComponent_ng_container_2_div_1_Template, 14, 7, "div", 22);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.isSimplifyH1b ? true : false);
} }
function ReviewPetitionLibraryComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 29);
    i0.ɵɵelementStart(1, "div", 30);
    i0.ɵɵelementStart(2, "lib-assigning-task-library", 31);
    i0.ɵɵlistener("updateStatus", function ReviewPetitionLibraryComponent_div_3_Template_lib_assigning_task_library_updateStatus_2_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r17 = i0.ɵɵnextContext(); return ctx_r17.updateStepStatus($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("visaType", ctx_r2.inputData.visatype)("stepDetails", ctx_r2.stepDetails)("isViewMode", ctx_r2.inputData["isViewMode"])("isCaseRequest", ctx_r2.inputData["isCaseRequest"]);
} }
function ReviewPetitionLibraryComponent_ng_container_4_p_divider_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider", 33);
} }
function ReviewPetitionLibraryComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ReviewPetitionLibraryComponent_ng_container_4_p_divider_1_Template, 1, 0, "p-divider", 32);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.isSimplifyH1b ? false : true);
} }
function ReviewPetitionLibraryComponent_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelement(1, "lib-last-update-library", 34);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("inputDetails", ctx_r4.stepDetails)("primaryData", ctx_r4.inputData)("sectionCode", ctx_r4.sectionCode);
} }
function ReviewPetitionLibraryComponent_p_divider_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "p-divider");
} }
function ReviewPetitionLibraryComponent_p_tabPanel_12_button_15_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 52);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_12_button_15_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r23); const ctx_r22 = i0.ɵɵnextContext(2); return ctx_r22.showResults(); });
    i0.ɵɵtext(1, " SHOW RESULTS ");
    i0.ɵɵelementEnd();
} }
function ReviewPetitionLibraryComponent_p_tabPanel_12_span_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 53);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" Generated On ", ctx_r21.PATimestamp, " ");
} }
function ReviewPetitionLibraryComponent_p_tabPanel_12_Template(rf, ctx) { if (rf & 1) {
    const _r25 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabPanel", 35);
    i0.ɵɵelementStart(1, "div", 36);
    i0.ɵɵelementStart(2, "div", 37);
    i0.ɵɵelementStart(3, "div", 38);
    i0.ɵɵelementStart(4, "div", 29);
    i0.ɵɵelementStart(5, "div", 39);
    i0.ɵɵelementStart(6, "span", 40);
    i0.ɵɵtext(7, " What is Petition Analysis?");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 41);
    i0.ɵɵelementStart(9, "span", 42);
    i0.ɵɵtext(10, "Click on \"ADJUDICATE PETITION\" button to generate latest analysis ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 43);
    i0.ɵɵelementStart(12, "button", 44);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_12_Template_button_click_12_listener() { i0.ɵɵrestoreView(_r25); const ctx_r24 = i0.ɵɵnextContext(); return ctx_r24.generatePetitionAnalysis(); });
    i0.ɵɵelement(13, "img", 45);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 46);
    i0.ɵɵtemplate(15, ReviewPetitionLibraryComponent_p_tabPanel_12_button_15_Template, 2, 0, "button", 47);
    i0.ɵɵtemplate(16, ReviewPetitionLibraryComponent_p_tabPanel_12_span_16_Template, 2, 1, "span", 48);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 49);
    i0.ɵɵelement(18, "img", 50);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 29);
    i0.ɵɵelementStart(20, "div", 51);
    i0.ɵɵelementStart(21, "p");
    i0.ɵɵtext(22, "Imagility\u2019s Petition Analysis checks the various petition elements against the requirements from USCIS and generates a consolidated report at the end of the process. At the click of a button, the system starts the petition adjudication process. The system analyses various elements of the petition like all filing requirements, petitioner requirements, position details, presence of required documents, correct fees, etc. At the end of the process, users shall be able to view the report that visually represents the completeness of the petition, findings from the analysis and recommendations from Imagility. ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance(15);
    i0.ɵɵproperty("ngIf", ctx_r7.PATimestamp);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r7.PATimestamp);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_6_div_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r36 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("", ctx_r36.reviewerInformation.firstName + " " + (ctx_r36.reviewerInformation == null ? null : ctx_r36.reviewerInformation.lastName), " ");
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_6_div_0_Template, 3, 1, "div", 1);
} if (rf & 2) {
    const ctx_r32 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngIf", ctx_r32.reviewerInformation.id);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const reviewer_r37 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate((reviewer_r37 == null ? null : reviewer_r37.firstName) + " " + (reviewer_r37 == null ? null : reviewer_r37.lastName));
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r39 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 75);
    i0.ɵɵelementStart(1, "button", 82);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_div_16_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r39); const ctx_r38 = i0.ɵɵnextContext(3); return ctx_r38.handleNotifyReviewer(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r35 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("disabled", ctx_r35.disabledControls || ctx_r35.previousStepStatus);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template(rf, ctx) { if (rf & 1) {
    const _r41 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 68);
    i0.ɵɵelementStart(1, "div", 69);
    i0.ɵɵelementStart(2, "label", 70);
    i0.ɵɵtext(3, "Reviewer Name");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "p-dropdown", 71, 72);
    i0.ɵɵlistener("ngModelChange", function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template_p_dropdown_ngModelChange_4_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r40 = i0.ɵɵnextContext(2); return ctx_r40.reviewerInformation = $event; })("onChange", function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template_p_dropdown_onChange_4_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r42 = i0.ɵɵnextContext(2); return ctx_r42.userSelected($event); });
    i0.ɵɵtemplate(6, ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_6_Template, 1, 1, "ng-template", 73);
    i0.ɵɵtemplate(7, ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_ng_template_7_Template, 3, 1, "ng-template", 74);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 75);
    i0.ɵɵelementStart(9, "label", 70);
    i0.ɵɵtext(10, "Designation");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 76);
    i0.ɵɵelementStart(12, "input", 77, 78);
    i0.ɵɵlistener("ngModelChange", function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template_input_ngModelChange_12_listener($event) { i0.ɵɵrestoreView(_r41); const ctx_r43 = i0.ɵɵnextContext(2); return ctx_r43.reviewerInformation.reviewerDesignation = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 79);
    i0.ɵɵelementStart(15, "button", 80);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r41); const ctx_r44 = i0.ɵɵnextContext(2); return ctx_r44.saveReviewerDetails(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(16, ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_div_16_Template, 2, 1, "div", 81);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r26 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r26.users)("ngModel", ctx_r26.reviewerInformation)("disabled", ctx_r26.disabledControls || ctx_r26.previousStepStatus);
    i0.ɵɵadvance(8);
    i0.ɵɵproperty("ngModel", ctx_r26.reviewerInformation.reviewerDesignation);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", ctx_r26.disabledControls || ctx_r26.previousStepStatus ? "btn-success  mr-3 btn-success_disabled" : "btn-success mr-3")("disabled", ctx_r26.disabledControls || ctx_r26.previousStepStatus);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r26.reviewerInformation.id);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_24_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 84);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r45 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r45.getGlobalErrorMessages("REQUIRED"), " ");
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ReviewPetitionLibraryComponent_p_tabPanel_16_div_24_span_1_Template, 2, 1, "span", 83);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", _r5.controls["reviewCode"].errors == null ? null : _r5.controls["reviewCode"].errors.required);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_button_26_Template(rf, ctx) { if (rf & 1) {
    const _r47 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 85);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_16_button_26_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r47); const ctx_r46 = i0.ɵɵnextContext(2); return ctx_r46.submitReview(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngClass", _r5.form.invalid || ctx_r29.disabledControls || ctx_r29.previousStepStatus ? "btn btn-success  btn-success_disabled" : "btn btn-primary")("disabled", _r5.form.invalid || ctx_r29.disabledControls || ctx_r29.previousStepStatus);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_button_27_Template(rf, ctx) { if (rf & 1) {
    const _r49 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 85);
    i0.ɵɵlistener("click", function ReviewPetitionLibraryComponent_p_tabPanel_16_button_27_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r49); const ctx_r48 = i0.ɵɵnextContext(2); return ctx_r48.submitReview(); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵnextContext(2);
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵproperty("ngClass", _r5.form.invalid ? "btn btn-success  btn-success_disabled" : "btn btn-primary")("disabled", _r5.form.invalid);
} }
function ReviewPetitionLibraryComponent_p_tabPanel_16_Template(rf, ctx) { if (rf & 1) {
    const _r51 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "p-tabPanel", 54);
    i0.ɵɵelementStart(1, "span", 55);
    i0.ɵɵtext(2, "\"Review Status\" or \"Submit for Review\"");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 36);
    i0.ɵɵelementStart(4, "div", 29);
    i0.ɵɵelementStart(5, "div", 56);
    i0.ɵɵelementStart(6, "span", 40);
    i0.ɵɵtext(7, "Reviwer Details");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "div", 57);
    i0.ɵɵelementStart(9, "p", 58);
    i0.ɵɵtext(10, "Note: Reviewer details can be updated after previous step is marked complete");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(11, ReviewPetitionLibraryComponent_p_tabPanel_16_div_11_Template, 17, 7, "div", 59);
    i0.ɵɵelementStart(12, "div", 60);
    i0.ɵɵelementStart(13, "span", 40);
    i0.ɵɵtext(14, "Add Comments");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 30);
    i0.ɵɵelementStart(16, "label");
    i0.ɵɵtext(17, "Add Comments / Notes");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "textarea", 61);
    i0.ɵɵlistener("ngModelChange", function ReviewPetitionLibraryComponent_p_tabPanel_16_Template_textarea_ngModelChange_18_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r50 = i0.ɵɵnextContext(); return ctx_r50.review.reviewNote = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 62);
    i0.ɵɵelementStart(20, "label", 63);
    i0.ɵɵtext(21, "Review ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(22, "p-dropdown", 64, 65);
    i0.ɵɵlistener("ngModelChange", function ReviewPetitionLibraryComponent_p_tabPanel_16_Template_p_dropdown_ngModelChange_22_listener($event) { i0.ɵɵrestoreView(_r51); const ctx_r52 = i0.ɵɵnextContext(); return ctx_r52.review.reviewCode = $event; });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(24, ReviewPetitionLibraryComponent_p_tabPanel_16_div_24_Template, 2, 1, "div", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(25, "div", 66);
    i0.ɵɵtemplate(26, ReviewPetitionLibraryComponent_p_tabPanel_16_button_26_Template, 1, 2, "button", 67);
    i0.ɵɵtemplate(27, ReviewPetitionLibraryComponent_p_tabPanel_16_button_27_Template, 1, 2, "button", 67);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    const _r5 = i0.ɵɵreference(8);
    i0.ɵɵadvance(11);
    i0.ɵɵproperty("ngIf", ctx_r8.reviewerInformation);
    i0.ɵɵadvance(7);
    i0.ɵɵproperty("ngModel", ctx_r8.review.reviewNote)("disabled", ctx_r8.disabledControls || ctx_r8.previousStepStatus);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("options", ctx_r8.reviewStatusList)("ngModel", ctx_r8.review.reviewCode)("disabled", ctx_r8.disabledControls || ctx_r8.previousStepStatus);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", _r5.controls["reviewCode"].touched && _r5.controls["reviewCode"].invalid);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r8.isWizard);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r8.isWizard);
} }
function ReviewPetitionLibraryComponent_div_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 87);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r9.inputData.caseType != "I130" ? ctx_r9.inputData.visatype : ctx_r9.inputData.caseType)("stepDetails", ctx_r9.stepDetails)("type", "NONE")("showPreviousStepBtn", true)("showNextStepBtn", true);
} }
function ReviewPetitionLibraryComponent_div_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 86);
    i0.ɵɵelement(1, "lib-step-status-update-component-library", 88);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("visaType", ctx_r10.inputData.caseType != "I130" ? ctx_r10.inputData.visatype : ctx_r10.inputData.caseType)("stepDetails", ctx_r10.stepDetails)("type", ctx_r10.typeOfButton);
} }
class ReviewPetitionLibraryComponent extends BaseReviewPetitionLibraryService {
    constructor(authenticationService, store, apiService, toastr, stepStatusUpdatePayloadCostructionService, guard, dialogService, appServicesLibraryService) {
        super(authenticationService, store, apiService, toastr, stepStatusUpdatePayloadCostructionService, guard, dialogService, appServicesLibraryService);
        this.authenticationService = authenticationService;
        this.store = store;
        this.apiService = apiService;
        this.toastr = toastr;
        this.stepStatusUpdatePayloadCostructionService = stepStatusUpdatePayloadCostructionService;
        this.guard = guard;
        this.dialogService = dialogService;
        this.appServicesLibraryService = appServicesLibraryService;
        this.onDialogClose = new EventEmitter();
    }
    ngOnInit() {
        var _a;
        this.isSimplifyH1b = this.simplifyH1b;
        this.inputData = this.primaryData;
        sessionStorage.setItem('petitionId', this.inputData.caseId.toString());
        super.loadInit();
        if ((_a = this.inputData) === null || _a === void 0 ? void 0 : _a.isBeneficiaryInitiate) {
            this.sectionCode = 'BEN_REVIEW_PETITION';
        }
        else {
            this.sectionCode = 'REVIEW';
        }
    }
    ngAfterViewInit() {
        this.printReviewForm = this.printReviewForm;
        super.ngAfterViewInit();
    }
    handleClose() {
        this.guard.canDeactivate().pipe(first()).subscribe((response) => {
            if (response) {
                this.onDialogClose.emit();
            }
            else {
                return false;
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
ReviewPetitionLibraryComponent.ɵfac = function ReviewPetitionLibraryComponent_Factory(t) { return new (t || ReviewPetitionLibraryComponent)(i0.ɵɵdirectiveInject(i1.AuthenticationService), i0.ɵɵdirectiveInject(i2.Store), i0.ɵɵdirectiveInject(i3.APIReviewPetition), i0.ɵɵdirectiveInject(i4.ToastrService), i0.ɵɵdirectiveInject(i5.StepStatusUpdatePayloadService), i0.ɵɵdirectiveInject(i6.DirtyFormGuard), i0.ɵɵdirectiveInject(i7.DialogService), i0.ɵɵdirectiveInject(i8.AppServicesLibraryService)); };
ReviewPetitionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: ReviewPetitionLibraryComponent, selectors: [["review-petition-library"]], viewQuery: function ReviewPetitionLibraryComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 3);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.printReviewForm = _t.first);
    } }, inputs: { primaryData: "primaryData", isWizard: "isWizard", simplifyH1b: "simplifyH1b" }, outputs: { onDialogClose: "onDialogClose" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 19, vars: 14, consts: [[1, "fluid-container"], [4, "ngIf"], ["class", "row", 4, "ngIf"], [3, "ngClass"], ["printReviewForm", "ngForm"], [1, "col-12"], ["styleClass", "review-petition-tab-view"], ["header", "Petition Analysis", 4, "ngIf"], ["header", "Update/Generate Draft Petition"], [1, "pt-3"], [3, "disabledControls", "isWizard", "primaryData"], ["header", "Reviewer Info & Feedback", 4, "ngIf"], ["class", "col-md-12 pt-3 completeStep", 4, "ngIf"], ["class", "row pt-4 d-flex align-items-center", 4, "ngIf"], [1, "row", "pt-4", "d-flex", "align-items-center"], [1, "col-md-9", "step-title", "p-0"], [1, "page-header"], [1, "col-md-2", "editBtn"], ["type", "EDIT", 3, "visaType", "stepDetails", "isViewMode", "isCaseRequest"], [1, "col-md-1", "pr-0", "pl-2", "d-flex", "justify-content-end"], [3, "configData"], [1, "close-icon", "pi", "pi-times", 3, "click"], ["class", "row pt-1 pl-3 d-flex align-items-center", 4, "ngIf"], [1, "row", "pt-1", "pl-3", "d-flex", "align-items-center"], [1, "page-header", "pl-0", "headerPortion"], [1, "m-0"], [1, "col-md-3", "editBtn", "headerSubPortion", "px-0"], [1, "col-auto", "px-0", "firstPortion"], [1, "col-auto", "pr-0", "pl-2", "secondPortion"], [1, "row"], [1, "col-md-12", "p-0"], [3, "visaType", "stepDetails", "isViewMode", "isCaseRequest", "updateStatus"], ["class", "header-divider", 4, "ngIf"], [1, "header-divider"], [3, "inputDetails", "primaryData", "sectionCode"], ["header", "Petition Analysis"], [1, "petition-analysis-holder"], [1, "row", "mb-3"], [1, "col-md-8", "row", "pl-0"], [1, "col-md-12", "pl-0", "mb-3"], [1, "review-info-sub-title"], [1, "col-md-12", "pl-0"], [2, "font-size", "14px"], [1, "col-md-6", "pl-0"], ["pButton", "", "type", "button", "label", "ADJUDICATE PETITION", 1, "im-btn", "im-btn-primary", "im-btn-md", 2, "margin-right", "20px", 3, "click"], ["src", "../../../../../assets/images/statistics_icn_white.png", 2, "padding-right", "10px"], [1, "col-md-6"], ["type", "button", "style", "margin-right: 20px;", "class", "im-btn im-btn-primary im-btn-md", 3, "click", 4, "ngIf"], ["class", "row", "style", "font-size: 13px;", 4, "ngIf"], [1, "col-md-4", "pl-0", "d-flex", "justify-content-center"], ["alt", "Petition Analysis", "width", "150px", "src", "../../../assets/Petition_analysis_img.png"], [1, "col-md-12", "pl-0", "text-justify"], ["type", "button", 1, "im-btn", "im-btn-primary", "im-btn-md", 2, "margin-right", "20px", 3, "click"], [1, "row", 2, "font-size", "13px"], ["header", "Reviewer Info & Feedback"], [1, "review-info-title"], [1, "col-12", "pl-0", "mb-3"], [1, "col-12", "pl-0", "mb-2"], [1, "review-info-text", "mb-0"], ["class", "row align-items-end", 4, "ngIf"], [1, "col-12", "pl-0", "mt-4", "mb-3"], ["name", "reviewNote", "placeholder", "Enter", 1, "w-100", "mw-100", 3, "ngModel", "disabled", "ngModelChange"], [1, "col-md-4", "p-0", "processing-dropdown"], [1, "required"], ["name", "reviewCode", "optionValue", "stepReviewCode", "optionLabel", "stepReviewDescription", "placeholder", "Select a Status", "required", "", 3, "options", "ngModel", "disabled", "ngModelChange"], ["reviewCode", "ngModel"], [1, "col-md-7", "p-0", "pt-3"], ["pButton", "", "type", "button", "label", "Submit", "type", "button", "class", "im-btn im-btn-primary im-btn-md", 3, "ngClass", "disabled", "click", 4, "ngIf"], [1, "row", "align-items-end"], [1, "col-4", "pl-0", "form-group", "processing-dropdown"], [1, "label-cls", "row", "required"], ["name", "reviewerId", "placeholder", "select", 3, "options", "ngModel", "disabled", "ngModelChange", "onChange"], ["reviewerId", "ngModel"], ["pTemplate", "selectedItem"], ["pTemplate", "item"], [1, "col-3", "pl-0", "form-group"], [1, "Wrapper"], ["name", "reviewerDesignation", "pInputText", "", "type", "text", "required", "", "readOnly", "", 1, "im-input", "mw-100", 3, "ngModel", "ngModelChange"], ["reviewerDesignation", "ngModel"], [1, "col-2", "pl-0", "form-group"], ["pButton", "", "type", "button", "label", "Update", 1, "btn-primary", 3, "ngClass", "disabled", "click"], ["class", "col-3 pl-0 form-group", 4, "ngIf"], ["pButton", "", "type", "button", "label", "Notify Reviewer", "icon", "pi pi-bell", "iconPos", "left", 1, "p-button-outlined", "notifier-btn", 3, "disabled", "click"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], ["pButton", "", "type", "button", "label", "Submit", "type", "button", 1, "im-btn", "im-btn-primary", "im-btn-md", 3, "ngClass", "disabled", "click"], [1, "col-md-12", "pt-3", "completeStep"], [1, "d-flex", "col-12", "justify-content-end", 3, "visaType", "stepDetails", "type", "showPreviousStepBtn", "showNextStepBtn"], [1, "justify-content-center", "d-flex", 3, "visaType", "stepDetails", "type"]], template: function ReviewPetitionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵtemplate(1, ReviewPetitionLibraryComponent_ng_container_1_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(2, ReviewPetitionLibraryComponent_ng_container_2_Template, 2, 1, "ng-container", 1);
        i0.ɵɵtemplate(3, ReviewPetitionLibraryComponent_div_3_Template, 3, 4, "div", 2);
        i0.ɵɵtemplate(4, ReviewPetitionLibraryComponent_ng_container_4_Template, 2, 1, "ng-container", 1);
        i0.ɵɵelementStart(5, "div", 3);
        i0.ɵɵtemplate(6, ReviewPetitionLibraryComponent_ng_container_6_Template, 2, 3, "ng-container", 1);
        i0.ɵɵelementStart(7, "form", null, 4);
        i0.ɵɵtemplate(9, ReviewPetitionLibraryComponent_p_divider_9_Template, 1, 0, "p-divider", 1);
        i0.ɵɵelementStart(10, "div", 5);
        i0.ɵɵelementStart(11, "p-tabView", 6);
        i0.ɵɵtemplate(12, ReviewPetitionLibraryComponent_p_tabPanel_12_Template, 23, 2, "p-tabPanel", 7);
        i0.ɵɵelementStart(13, "p-tabPanel", 8);
        i0.ɵɵelementStart(14, "div", 9);
        i0.ɵɵelement(15, "lib-review-petiton-new", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(16, ReviewPetitionLibraryComponent_p_tabPanel_16_Template, 28, 9, "p-tabPanel", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(17, ReviewPetitionLibraryComponent_div_17_Template, 2, 5, "div", 12);
        i0.ɵɵtemplate(18, ReviewPetitionLibraryComponent_div_18_Template, 2, 3, "div", 12);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", !ctx.isWizard ? "main-body" : "main-body-wizard");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isWizard);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype === "H1-B" && ctx.isWizard);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.inputData.visatype === "H1-B");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("disabledControls", ctx.disabledControls || ctx.previousStepStatus)("isWizard", ctx.isWizard)("primaryData", ctx.primaryData);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.primaryData.isBeneficiaryInitiate);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.inputData.isBeneficiaryInitiate && !ctx.isWizard);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.inputData.isBeneficiaryInitiate);
    } }, directives: [i9.NgIf, i9.NgClass, i10.ɵangular_packages_forms_forms_ba, i10.NgControlStatusGroup, i10.NgForm, i11.TabView, i11.TabPanel, i12.ReviewPetitonNewComponent, i13.StepStatusUpdateComponentLibraryComponent, i14.MaximizeDialogLibraryComponent, i15.AssigningTaskLibraryComponent, i16.Divider, i17.LastUpdateLibraryComponent, i18.ButtonDirective, i10.DefaultValueAccessor, i10.NgControlStatus, i10.NgModel, i19.Dropdown, i10.RequiredValidator, i20.PrimeTemplate, i21.InputText], styles: [".close-icon[_ngcontent-%COMP%]{color:#fff;background-color:#000;padding:8px;border-radius:20px;font-weight:700;cursor:pointer}.p-inputtext[_ngcontent-%COMP%]{border-color:#ced4da!important}.save-btn[_ngcontent-%COMP%]{background-color:#19a0da;padding:0 30px!important;font-size:14px!important;border-radius:8px!important}.notifier-btn[_ngcontent-%COMP%]{padding:0 10px!important}.add-comments[_ngcontent-%COMP%]   label[_ngcontent-%COMP%]{font-size:14px;color:#4a4a4a}.generateDraft[_ngcontent-%COMP%]{font-size:14px;padding-left:10px}.main-body[_ngcontent-%COMP%]{height:calc(100vh - 110px)!important;width:100%;overflow:auto;padding-right:0!important}.headerPortion[_ngcontent-%COMP%]   h2[_ngcontent-%COMP%]{color:#002e83;font-weight:600}.heading-big-wizard[_ngcontent-%COMP%]{color:#3498db;font-weight:700;font-size:1.75rem;margin-bottom:15px}.main-body-wizard[_ngcontent-%COMP%]{width:100%;overflow:auto;padding-right:0!important}.petition-analysis-holder[_ngcontent-%COMP%]{padding:15px;background-color:#f0f9fe;margin:15px 0;box-shadow:0 1px 3px 0 rgba(0,0,0,.3)}.review-info-title[_ngcontent-%COMP%]{font-style:italic;margin:15px 0;display:block;font-weight:600;color:#626262}.review-info-sub-title[_ngcontent-%COMP%]{font-weight:700;color:#626262}.review-info-text[_ngcontent-%COMP%]{font-size:14px;color:#626262}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'review-petition-library',
                templateUrl: 'review-petition-library.component.html',
                styleUrls: ['review-petition-library.component.scss']
            }]
    }], function () { return [{ type: i1.AuthenticationService }, { type: i2.Store }, { type: i3.APIReviewPetition }, { type: i4.ToastrService }, { type: i5.StepStatusUpdatePayloadService }, { type: i6.DirtyFormGuard }, { type: i7.DialogService }, { type: i8.AppServicesLibraryService }]; }, { primaryData: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], onDialogClose: [{
            type: Output
        }], printReviewForm: [{
            type: ViewChild,
            args: ['printReviewForm', { static: true }]
        }], simplifyH1b: [{
            type: Input
        }] }); })();

class ReviewPetitionLibraryModule {
}
ReviewPetitionLibraryModule.ɵfac = function ReviewPetitionLibraryModule_Factory(t) { return new (t || ReviewPetitionLibraryModule)(); };
ReviewPetitionLibraryModule.ɵmod = i0.ɵɵdefineNgModule({ type: ReviewPetitionLibraryModule });
ReviewPetitionLibraryModule.ɵinj = i0.ɵɵdefineInjector({ providers: [BaseReviewPetitionLibraryService], imports: [[
            CommonModule,
            PrimengLibraryModule,
            StepStatusUpdateComponentLibraryModule,
            ReviewCommentsLibraryModule,
            DateFormatModule,
            LastUpdateLibraryModule,
            AssigningTaskLibraryModule,
            NgxPermissionsModule.forChild(),
            MaximizeDialogLibraryModule,
            ReviewPetitonNewModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(ReviewPetitionLibraryModule, { declarations: [ReviewPetitionLibraryComponent], imports: [CommonModule,
        PrimengLibraryModule,
        StepStatusUpdateComponentLibraryModule,
        ReviewCommentsLibraryModule,
        DateFormatModule,
        LastUpdateLibraryModule,
        AssigningTaskLibraryModule, i1$1.NgxPermissionsModule, MaximizeDialogLibraryModule,
        ReviewPetitonNewModule], exports: [ReviewPetitionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ReviewPetitionLibraryModule, [{
        type: NgModule,
        args: [{
                declarations: [ReviewPetitionLibraryComponent],
                imports: [
                    CommonModule,
                    PrimengLibraryModule,
                    StepStatusUpdateComponentLibraryModule,
                    ReviewCommentsLibraryModule,
                    DateFormatModule,
                    LastUpdateLibraryModule,
                    AssigningTaskLibraryModule,
                    NgxPermissionsModule.forChild(),
                    MaximizeDialogLibraryModule,
                    ReviewPetitonNewModule
                ],
                providers: [BaseReviewPetitionLibraryService],
                exports: [ReviewPetitionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of review-petition-library
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ReviewPetitionLibraryComponent, ReviewPetitionLibraryModule, ReviewPetitionLibraryService };
//# sourceMappingURL=review-petition-library.js.map
